const state = {
    // 登录账号的所在机构类型 1：腾慧  2：珊瑚
    isShanhu: localStorage.getItem('tengface_is_shanhu') || 2,
    org_id: localStorage.getItem('tengface_org_id') || "",
    fans_id:localStorage.getItem('tengface_fans_id') || "",
    remark:localStorage.getItem('tengface_remark')||'',
    licenseUrl:'https://license.vod2.myqcloud.com/license/v2/1317978474_1/v_cube.license',
}

const getters = {
    getRemark(state){
        return state.remark
    },
    getOrgId(state){
		return state.org_id
	},
    getFansId(state){
		return state.fans_id
	},
    getIsShanhuState(state) {
        try {
            return Number(state.isShanhu) === 2
        } catch (error) {
            return false
        }
    },
    getLicenseUrl(state) {
        return state.licenseUrl
    },
}

const actions = {
   
}

const mutations = {
   setOrgID(state, data){
       state.org_id = data
   },
   setFansId(state,data){
    state.fans_id = data
    localStorage.setItem('tengface_fans_id', data)
   },
   setIsShanhuState(state, data){
       state.isShanhu = data
   },
   setRemark(state, data){
    state.remark = data
    localStorage.setItem('tengface_remark',data)
   },
   setLicenseUrl(state, data){
    state.licenseUrl = data
   },
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
